<template>
  <div>
    <b-row align-v="center" class="justify-content-start mb-1" no-gutters>
      <b-col cols="1.8">
        <b-form-select v-model="data.hour" :options="hourOptions" plain/>
      </b-col>
      <b-col cols="1.8" class="ml-2">
        <b-form-select v-model="data.minute" :options="minuteOptions" plain/>
      </b-col>
      <b-col md="auto" class="ml-3">
        <b-button variant="outline-success" class="mb-2 mr-sm-3 mb-sm-0" size="xs" @click="onClickDelete"
                  :hidden="params.id < 1">삭제
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  export default {
    props: ['data'],
    data() {
      return {
        hoursArr: [],
        params: {
          id: null
        },
        hourOptions: [
          {value: null, text: '--시--', disabled: true},
          {value: 'h00', text: '00 시'},
          {value: 'h01', text: '01 시'},
          {value: 'h02', text: '02 시'},
          {value: 'h03', text: '03 시'},
          {value: 'h04', text: '04 시'},
          {value: 'h05', text: '05 시'},
          {value: 'h06', text: '06 시'},
          {value: 'h07', text: '07 시'},
          {value: 'h08', text: '08 시'},
          {value: 'h09', text: '09 시'},
          {value: 'h10', text: '10 시'},
          {value: 'h11', text: '11 시'},
          {value: 'h12', text: '12 시'},
          {value: 'h13', text: '13 시'},
          {value: 'h14', text: '14 시'},
          {value: 'h15', text: '15 시'},
          {value: 'h16', text: '16 시'},
          {value: 'h17', text: '17 시'},
          {value: 'h18', text: '18 시'},
          {value: 'h19', text: '19 시'},
          {value: 'h20', text: '20 시'},
          {value: 'h21', text: '21 시'},
          {value: 'h22', text: '22 시'},
          {value: 'h23', text: '23 시'},
        ],
        minuteOptions: [
          {value: null, text: '--분--', disabled: true},
          {value: 'm00', text: '00 분'},
          {value: 'm05', text: '05 분'},
          {value: 'm10', text: '10 분'},
          {value: 'm15', text: '15 분'},
          {value: 'm20', text: '20 분'},
          {value: 'm25', text: '25 분'},
          {value: 'm30', text: '30 분'},
          {value: 'm35', text: '35 분'},
          {value: 'm40', text: '40 분'},
          {value: 'm45', text: '45 분'},
          {value: 'm50', text: '50 분'},
          {value: 'm55', text: '55 분'},
        ],
      }
    },

    mounted() {
      this.params.id = this.data.id;
    },

    methods: {
      onClickDelete() {
        this.$emit('delete-hour', this.params.id)
      }
    }
  }
</script>
